import {
  FIXEDASSETFILETOFIELD,
  INVENTORYFILETOFIELD,
  LEASEDEQUIPMENTFILETOFIELD,
  LEASEDVEHICLEFILETOFIELD,
  PROPERTIESFILETOFIELD,
  VEHICLEFILETOFIELD,
} from '../../enums';
import {
  State,
  AssetField,
  OriginalFileField,
} from '../../interface';

type TypeColumnsKeys =
  | typeof FIXEDASSETFILETOFIELD
  | typeof INVENTORYFILETOFIELD
  | typeof VEHICLEFILETOFIELD
  | typeof LEASEDVEHICLEFILETOFIELD
  | typeof LEASEDEQUIPMENTFILETOFIELD
  | typeof PROPERTIESFILETOFIELD;

export interface Props {
  columnMappings: OriginalFileField[];
  assets: AssetField[];
  dataList: AssetField[];
  standardColumns: string[];
  checkedColumns: string[];
  additionColumn: string[];
  mappedKeys: TypeColumnsKeys;
  type: string;
  url?: string;
  onDeleteItem: (value: AssetField[]) => void;
  onUpdateAssets: (value: { columnMappings: OriginalFileField[]; items: AssetField[] }) => void;
  states: State[];
  fetching: boolean;
  updating: boolean;
}

export enum EModalConfirmationStep {
  DELETE = 'delete',
  UPDATE = 'update',
}

export type TModalConfirmation = {
  body: string;
  step: EModalConfirmationStep;
};
